export const ACTIVE_DIRECTORY_ACCOUNT_TYPE = 'Active Directory';
export default {};
